
const Home = () => import("../views/home/home.vue")
// 首师云首页
// const HomePage = () => import("../views/home-page.vue")
const HomePage = () => import("../views/home-page2.vue")
// 项目案例
const Case = () => import("../views/case.vue")


// ====服务平台====
// 课程中台
const courseList = () => import("../views/course_list.vue")
// 融合教学
const IntegratedTaching = () => import("../views/integrated.vue")
// 评价诊断
const Evaluation = () => import("../views/evaluation.vue")
// 教师智研
const Wisdom = () => import("../views//wisdom.vue")
// 院系服务
const Departmental = () => import("../views/departmental.vue")
// ====服务平台====

// 特色项目
const featuredItem = () => import("../views/featuredItem.vue")
// 同步课堂
const cloudSchool = () => import("../views/school2.vue")
// 同步教研
const syncJY = () => import("../views/school3.vue")
// 同步成长
const syncCZ = () => import("../views/school4.vue")
// 一校
const cloudSchool2 = () => import("../views/school5.vue")
// 协作项目
const xzProject = () => import("../views/project.vue")
// 教师队伍能力提升
const power = () => import("../views/power.vue")

// 首都远程互助工程
const helpProject = () => import("../views/helpProject.vue")
// 关于我们
const AboutUs = () => import("../views/aboutUs.vue")
// 联系我们
const ContactUs = () => import("../views/contactUs.vue")

// 新闻列表
const newsList = () => import("../views/news_list.vue")
// 新闻详情
const newsDetail = () => import("../views/news_detail.vue")
// 课程详情
const courseDetail = () => import("../views/course_detail.vue")
// 视频播放页
const asyncLive = () => import("../views/asynclive.vue")
// 驼铃杯
const cup = () => import("../views/cup3.vue")
const cup2 = () => import("../views/cup2.vue")
// 驼铃杯课程更多
const courseMore = () => import("../views/course_more.vue")
// 驼铃杯课程详情
const courseDetail2 = () => import("../views/course_detail2.vue")
// 驼铃杯论坛
const forum = () => import("../views/forum2.vue")


// 中心业务
const business = () => import("../views/business.vue")
// 社会责任
const responsibility = () => import("../views/responsibility.vue")
// 中心概况
const general = () => import("../views/general/general.vue")
// 中心简介
const introduction = () => import("../views/general/introduction.vue")
// 中心优势
const advantage = () => import("../views/general/advantage.vue")
// 机构设置
const organ = () => import("../views/general/organ.vue")
// 中心荣誉
const honour = () => import("../views/general/honour.vue")
// 联系我们
const contactus = () => import("../views/general/contactus.vue")
// 专家工作室入口
const studioEntrance = () => import("../views/studio/studio-entrance.vue")
// 专家工作室
const studio = () => import("../views/studio/studio.vue")
// 工作室首页
const studioIntroduce = () => import("../views/studio/introduction.vue")
// 主持人简介
const hostIntroduce = () => import("../views/studio/host-introduction.vue")
// 团队成员
const member = () => import("../views/studio/member.vue")
// 特色项目
const project = () => import("../views/studio/project.vue")
// 专项课程
const course = () => import("../views/studio/course.vue")
// 项目详情
const projectDetail = () => import("../views/studio/project_detail.vue")

// 研学详情
const detail = () => import("../views/jm/detail.vue")
const tabel = () => import("../views/jm/tabel.vue")
const view = () => import("../views/jm/view.vue")
const edit = () => import("../views/jm/edit.vue")

// 云端学校
// const cloudSchool = () => import("../views/cloudSchool.vue")

// 教改实践
const shijian = () => import("../views/shijian2.vue")
const detail2 = () => import("../views/detail.vue")

// 日历
const calendar = () => import("../views/calendar.vue")

const video = () => import("../views/video.vue")
// 组团式教育帮扶
const help = () => import("../views/help.vue")
// 完善资料
const upDateInfo = () => import("../views/update_userInfo_cloud.vue")
const upDateInfoCA = () => import("../views/update_userInfo_ca.vue")
// 虚拟账号完善资料
const updateUserInfo = () => import('../views/update_userInfo.vue')
//指南
const handbook = () => import('../views/fingerpost/handbook.vue')
const help_video = () => import('../views/fingerpost/help_video.vue')
const help_pdf = () => import('../views/fingerpost/help_pdf.vue')
// 课程
const curriculum = () => import("../views/curriculum/curriculum.vue")
const curriculumPublic = () => import("../views/curriculum/curriculumPublic.vue")
const courseDescription = () => import("../views/curriculum/courseDescription.vue")
const curriculumVideo = () => import("../views/curriculum/curriculumVideo.vue")
export default [{
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            title: '首页',
            keepAlive: false
        },
        redirect: {
            name: 'HomePage'
        },
        children: [

            {
                path: 'page',
                name: 'HomePage',
                component: HomePage,
                meta: {
                    title: '首页',
                    keepAlive: false
                }
            },
            {
                path: 'courseMore',
                name: 'courseMore',
                component: courseMore,
                meta: {
                    title: '课程展示',
                    keepAlive: true
                }
            },
            {
                path: 'courseDetail2',
                name: 'courseDetail2',
                component: courseDetail2,
                meta: {
                    title: '课程详情',
                    keepAlive: false
                }
            },
            {
                path: 'business',
                name: 'business',
                component: business,
                meta: {
                    title: '中心业务',
                    keepAlive: false
                }
            },
            {
                path: 'general',
                name: 'general',
                component: general,
                meta: {
                    title: '中心概况',
                    keepAlive: false
                },
                redirect: {
                    name: 'introduction'
                },
                children: [{
                        path: 'introduction',
                        name: 'introduction',
                        component: introduction,
                        meta: {
                            title: '中心简介',
                            keepAlive: false
                        }
                    },
                    {
                        path: 'advantage',
                        name: 'advantage',
                        component: advantage,
                        meta: {
                            title: '中心优势',
                            keepAlive: false
                        }
                    },
                    {
                        path: 'organ',
                        name: 'organ',
                        component: organ,
                        meta: {
                            title: '机构设置',
                            keepAlive: false
                        }
                    },
                    {
                        path: 'honour',
                        name: 'honour',
                        component: honour,
                        meta: {
                            title: '中心荣誉',
                            keepAlive: false
                        }
                    },
                    {
                        path: 'contactus',
                        name: 'contactus',
                        component: contactus,
                        meta: {
                            title: '联系我们',
                            keepAlive: false
                        }
                    },
                ]
            },

            {
                path: 'studioEntrance',
                name: 'studioEntrance',
                component: studioEntrance,
                meta: {
                    title: '专家工作室',
                    keepAlive: false
                },
            },
            {
                path: 'studio/:id',
                name: 'studio',
                component: studio,
                meta: {
                    title: '工作室',
                    keepAlive: false
                },
                redirect: {
                    name: 'studstudioIntroduce'
                },
                children: [{
                        path: 'studioIntroduce',
                        name: 'studstudioIntroduce',
                        component: studioIntroduce,
                        meta: {
                            title: '工作室简介',
                            keepAlive: false
                        },
                    },
                    {
                        path: 'hostIntroduce',
                        name: 'hostIntroduce',
                        component: hostIntroduce,
                        meta: {
                            title: '主持人简介',
                            keepAlive: false
                        },
                    }, {
                        path: 'member',
                        name: 'member',
                        component: member,
                        meta: {
                            title: '团队成员',
                            keepAlive: false
                        },
                    }, {
                        path: 'project',
                        name: 'project',
                        component: project,
                        meta: {
                            title: '特色项目',
                            keepAlive: false
                        },
                    }, {
                        path: 'course',
                        name: 'course',
                        component: course,
                        meta: {
                            title: '专项课程',
                            keepAlive: false
                        },
                    }
                ]
            },
            {
                path: 'responsibility',
                name: 'responsibility',
                component: responsibility,
                meta: {
                    title: '社会责任',
                    keepAlive: false
                }
            },
            {
                path: 'case',
                name: 'Case',
                component: Case,
                meta: {
                    title: '中心案例',
                    keepAlive: false
                }
            },
            {
                path: 'project/detail/:id',
                name: 'projectDetail',
                component: projectDetail,
                meta: {
                    title: '项目详情',
                    keepAlive: false
                },

            },
            {
                path: 'courseList',
                name: 'courseList',
                component: courseList,
                meta: {
                    title: '课程中台',
                    keepAlive: false
                }
            },
            {
                path: 'integratedTaching',
                name: 'IntegratedTaching',
                component: IntegratedTaching,
                meta: {
                    title: '融合教学',
                    keepAlive: false
                }
            },
            {
                path: 'evaluation',
                name: 'evaluation',
                component: Evaluation,
                meta: {
                    title: '评价诊断',
                    keepAlive: false
                }
            },
            {
                path: 'wisdom',
                name: 'wisdom',
                component: Wisdom,
                meta: {
                    title: '教师智研',
                    keepAlive: false
                }
            },
            {
                path: 'departmental',
                name: 'departmental',
                component: Departmental,
                meta: {
                    title: '院系服务',
                    keepAlive: false
                }
            },
            {
                path: 'featuredItem',
                name: 'featuredItem',
                component: featuredItem,
                meta: {
                    title: '特色项目',
                    keepAlive: false
                }
            },
            {
                path: 'school',
                name: 'cloudSchool',
                component: cloudSchool,
                meta: {
                    title: '同步课堂',
                    keepAlive: false
                }
            },
            {
                path: 'school2',
                name: 'cloudSchool2',
                component: cloudSchool2,
                meta: {
                    title: '同步课堂',
                    keepAlive: false
                }
            },
            {
                // syncJY
                path: 'syncJY',
                name: 'syncJY',
                component: syncJY,
                meta: {
                    title: '同步教研',
                    keepAlive: false
                }
            },
            {
                // syncJY
                path: 'syncCZ',
                name: 'syncCZ',
                component: syncCZ,
                meta: {
                    title: '同步成长',
                    keepAlive: false
                }
            },
            {
                path: 'xzProject',
                name: 'xzProject',
                component: xzProject,
                meta: {
                    title: '协作项目',
                    keepAlive: false
                }
            },
            {
                path: 'help',
                name: 'help',
                component: help,
                meta: {
                    title: '教育帮扶',
                    keepAlive: false
                }
            },
            {
                path: 'power',
                name: 'power',
                component: power,
                meta: {
                    title: '教师队伍能力提升',
                    keepAlive: false
                }
            },
            {
                path: 'help',
                name: 'helpProject',
                component: helpProject,
                meta: {
                    title: '首都远程互助工程',
                    keepAlive: false
                }
            },
            {
                path: 'about',
                name: 'AboutUs',
                component: AboutUs,
                meta: {
                    title: '关于我们',
                    keepAlive: false
                }
            },
            {
                path: 'contact',
                name: 'ContactUs',
                component: ContactUs,
                meta: {
                    title: '联系我们',
                    keepAlive: false
                }
            },
            {
                path: 'news',
                name: 'newsList',
                component: newsList,
                meta: {
                    title: '新闻列表',
                    keepAlive: false,
                    bread: true,
                }
            },
            {
                path: 'news/detail/:id',
                name: 'newsDetail',
                component: newsDetail,
                meta: {
                    title: '新闻详情页',
                    keepAlive: false,
                    bread: true,
                }
            },
            {
                path: 'course/detail/:id',
                name: 'courseDetail',
                component: courseDetail,
                meta: {
                    title: '课程详情',
                    keepAlive: false
                }
            },
            {
                path: 'course/live/:id',
                name: 'asyncLive',
                component: asyncLive,
                meta: {
                    title: '课程播放页',
                    keepAlive: false
                }
            },
            {
                path: 'cup',
                name: 'cup',
                component: cup,
                meta: {
                    title: '驼铃杯',
                    keepAlive: false
                }
            },
            {
                path: 'cup2',
                name: 'cup2',
                component: cup2,
                meta: {
                    title: '驼铃杯',
                    keepAlive: false
                }
            },
            {
                path: 'forum',
                name: 'forum',
                component: forum,
                meta: {
                    title: '驼铃杯论坛',
                    keepAlive: false
                }
            }, {
                path: 'shijian',
                name: 'shijian',
                component: shijian,
                meta: {
                    title: '教改实践',
                    keepAlive: false
                }
            }, {
                path: 'detail2',
                name: 'detail2',
                component: detail2,
                meta: {
                    title: '教改实践',
                    keepAlive: false
                }
            },
            {
                path: 'video',
                component: video,
            },
            {
                path: 'curriculumPublic',
                name: 'curriculumPublic',
                component: curriculumPublic,
                meta: {
                    title: '课程',
                    keepAlive: false,
                    bread: true,
                    // type:'course'
                },
            },
            {
                path: 'curriculumPublic/detail/:id',
                name: 'courseDescription',
                component: courseDescription,
                meta: {
                    title: '课程详情',
                    keepAlive: false,
                    bread: true,
                    type:'course'
                },
            },
            {
                path: 'curriculumPublic/video/:id',
                name: 'curriculumVideo',
                component: curriculumVideo,
                meta: {
                    title: '视频播放',
                    keepAlive: false,
                    bread: true,
                    type:'course'
                },
            }
            // {
            //     path: 'courseDescription',
            //     name: 'courseDescription',
            //     component: courseDescription,
            //     meta: {
            //         title: '课程详情',
            //         keepAlive: false,
            //         bread: true,
            //         type: 'level3'
            //     },
            // },
            // {
            //     path: 'curriculumVideo',
            //     name: 'curriculumVideo',
            //     component: curriculumVideo,
            //     meta: {
            //         title: '视频播放',
            //         keepAlive: false,
            //         bread: true,
            //     },
            // }
        ]
    },
    {
        path: '/detail',
        name: 'detail',
        component: detail,
        meta: {
            title: '详情',
            keepAlive: false
        },
    },
    {
        path: '/tabel',
        name: 'tabel',
        component: tabel,
        meta: {
            title: '详情',
            keepAlive: false
        },
    },
    {
        path: '/view',
        name: 'view',
        component: view,
        meta: {
            title: '查看',
            keepAlive: false
        },
    },
    {
        path: '/edit',
        name: 'edit',
        component: edit,
        meta: {
            title: '编辑',
            keepAlive: false
        },
    },
    {
        path: '/calendar',
        component: calendar,
        meta: {
            title: '日历',
            keepAlive: false
        }
    },
    {
        path: '/upDateInfo',
        component: upDateInfo,
        meta: {
            title: '完善资料',
            keepAlive: false
        }
    },
    {
        path: '/upDateInfoCA',
        component: upDateInfoCA,
        meta: {
            title: '完善资料',
            keepAlive: false
        }
    },
    {
        path: '/updateUserInfo',
        component: updateUserInfo,
        meta: {
            title: '完善资料',
            keepAlive: false
        }
    },
    {
        path: '/help_video',
        name: 'help_video',
        component: help_video
    },
    {
        path: '/help_pdf',
        name: 'help_pdf',
        component: help_pdf
    },
    {
        path: '/handbook',
        name: 'handbook',
        component: handbook
    },
]